import DiceContainer from './DiceContainer';

export default DiceContainer;
export { DiceContainer };
